"use client";

import { motion } from "framer-motion";

export default function DnaTV() {
  return (
    <div className="relative w-full h-[260px] rounded-2xl
                    bg-black/60 border border-white/20
                    overflow-hidden shadow-inner">

      {/* Scan glow */}
      <div className="absolute inset-0
                      bg-gradient-to-b from-transparent
                      via-indigo-500/10 to-transparent
                      animate-pulse" />

      {/* DNA */}
      <motion.img
        src="/dna-helix.svg"
        alt="DNA"
        className="absolute left-1/2 top-1/2
                   w-[120px] opacity-90
                   -translate-x-1/2 -translate-y-1/2"
        animate={{
          y: [-20, 20, -20],
          rotate: [0, 180, 360],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "linear",
        }}
      />

      {/* Grid overlay */}
      <div className="absolute inset-0
                      bg-[linear-gradient(to_right,rgba(255,255,255,0.05)_1px,transparent_1px),
                          linear-gradient(to_bottom,rgba(255,255,255,0.05)_1px,transparent_1px)]
                      bg-[size:24px_24px]" />
    </div>
  );
}
